import { createIcon } from '@chakra-ui/icons';

export const OtherIcon = createIcon({
  displayName: 'OtherIcon',
  viewBox: '0 0 28 7',
  d: 'M17.5 3.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zM4 0a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm20 0a3.5 3.5 0 100 7 3.5 3.5 0 000-7z',
});
